import { render, staticRenderFns } from "./SubCategoryForm.vue?vue&type=template&id=63c33d9f"
import script from "./SubCategoryForm.vue?vue&type=script&lang=js"
export * from "./SubCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports